// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.navbar-container-title {
  flex-direction: row;
  display: flex;
}

.chelmsford-tablet {
  display: none;
}


.chelmsford-desktop span.btn-town {
  font-size: 18px !important;
}

.login-btn-hamb {
  display: none;
}

.navbar-yell {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  height: 5rem;
  position: relative;
}

.icon-notif-tablet {
  display: none;
}

.navbar-container {
  width: 100% !important;
}

.path-item a {
  text-decoration: none !important;
}

.navbar-title-header {
  text-decoration: none;
  color: rgb(143, 0, 60);
  background: 0% 0% no-repeat padding-box;
  align-self: center !important;
  text-align: center !important;
  font-family: "Lato", sans-serif !important;
}

.navbar-a {
  text-decoration: none;
  text-align: left;
  font-family: "Lato", sans-serif !important;
  font-size: 16px !important;
  font-weight: bold;
  letter-spacing: 0px;
  color: #1a1919;
  opacity: 1;
  padding-left: 20px;
  padding-right: 20px;
  align-self: center;
  text-align: center;
}

.navbar-subtitle-logo {
  font-family: "Lato", sans-serif !important;
  font-size: 18px;
  font-weight: bold;
  letter-spacing: 0px;
  color: #7f7f7f;
  opacity: 2;
  align-self: center;
  text-align: center;
  padding: 0px !important;
  margin: 0px !important;
  position: relative;
  right: 10px;
}
.navbar-subtitle-logo h5 {
  text-decoration: none;
}

.navbar-subtitle-logo-login {
  display: flex;
  justify-content: center !important;
  align-items: center !important;
  font-family: "Lato", sans-serif !important !important;
  font-size: 15px;
  font-weight: bold;
  letter-spacing: 0px;
  color: rgb(4, 4, 4);
  opacity: 2;
  align-self: center;
  text-align: center;
  padding: 0px !important;
  margin: 0px 0px 0px 3px !important;
  position: relative;
  right: 10px;
}
.navbar-subtitle-logo-login h5 {
  padding-left: 18spx !important;
}

.body-popover {
  padding-right: -3px !important;
  margin-top: -5px !important;
}

.header-popover {
  padding-left: 18px !important;
}

#popover-positioned-bottom {
  width: 200px;
}

.no-border {
  margin-right: 0px !important;
  margin-left: 0px !important;
  background-color: rgb(247, 248, 249);
}

.btn-town {
  text-align: left;
  align-self: center;
  font-family: "Lato", sans-serif !important;
  font-size: 18px;
  font-weight: 900;
  letter-spacing: 0px;
  color: #1a1919;
}

.homePage-navbar .navbar-light {
  background-color: #ffc14d;
  border-top-left-radius: 37px;
  border-bottom-left-radius: 37px;
  height: 3rem;
}

a {
  text-decoration: none !important;
}

.toggler-custom {
  background-color: 0 !important;
  border: 0px !important;
  padding: 0px !important;
  margin: 0 25px !important;
}

.toggler-custom-mobile {
  background-color: 0 !important;
  border: 0px !important;
  padding: 0px !important;
  margin: 0 25px !important;
}

.icon-menu {
  color: rgb(7, 6, 6) !important;
  font-size: 35px;
}

.icon-dropdown {
  padding-left: 5px;
  margin: 0px !important;
  align-self: center;
}

@media screen and (max-width: 992px) {
  .navbar-a {
    padding-left: 0px;
    padding-right: 0px;
  }
  .navbar-yell {
    background-color: #ffffff;
    z-index: 100;
    height: 12rem;
  }
  .navbar-label {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    align-content: center;
  }
  .btn-town-button {
    width: 80% !important;
    height: 2rem !important;
  }
  .btn-town {
    width: 100% !important;
    flex: 1 1 !important;
    display: flex;
    flex-direction: row;
    align-self: center;
    text-align: left;
    justify-content: space-between;
  }
  .login-btn-hamb {
    padding: 0 !important;
    margin-left: 2px;
  }
  .chelmsford-navbar-label {
    margin-top: 0px;
  }
  .chelmsford-tablet {
    margin-top: -9px;
  }
  .chelmsford-desktop {
    display: none;
  }
  .icon-notif-tablet {
    display: flex;
    font-size: 25px;
    color: black;
    margin-right: 25px;
    margin-left: 15px;
    align-self: center;
    position: relative;
    left: 37%;
  }
  .icon-dropdown {
    height: 2rem !important;
    display: flex !important;
    justify-content: center !important;
    align-items: center !important;
  }
  .me-auto {
    display: none !important;
  }
  .navbar-nav {
    width: 22rem !important;
    margin-left: 1rem;
    justify-content: flex-start;
  }
}
@media (max-width: 768px) {
  .icon-notif-tablet {
    display: flex;
    font-size: 25px;
    color: black;
    margin-right: 25px;
    margin-left: 15px;
    align-self: center;
    position: relative;
    left: 40% !important;
  }
}
@media screen and (max-width: 576px) {
  .navbar-label {
    width: 100%;
    align-items: center;
    justify-content: flex-start;
    align-content: center;
    display: flex;
  }
  .btn-town-button {
    width: 80% !important;
  }
  .btn-town {
    width: 100% !important;
    flex: 1 1 !important;
    display: flex;
    flex-direction: row;
    text-align: left;
    justify-content: space-between;
  }
}
.icon-notif {
  font-size: 25px;
  color: black;
  margin-right: 25px;
  margin-left: 15px;
  align-self: center;
}

.button-popover {
  align-self: flex-end !important;
  color: rgb(143, 0, 60) !important;
  font-family: "Lato", sans-serif !important;
}

.button-profile {
  align-self: flex-end !important;
  background-color: rgba(78, 125, 162, 0.15) !important;
  font-family: "Lato", sans-serif !important;
  border-radius: 25px !important;
  border: 1px solid rgb(78, 125, 162) !important;
  height: 50px;
  width: 50px;
}

.body-popover {
  display: flex !important;
  justify-content: flex-end;
}

.header-popover {
  background-color: rgba(0, 0, 0, 0) !important;
  font-family: "Lato", sans-serif !important !important;
  font-size: 16px;
  padding: 20px 10px 0px 10px;
}

.image-profile {
  height: 50px;
  width: 50px;
  background-color: red;
}

/*# sourceMappingURL=navbar.css.map */
`, "",{"version":3,"sources":["webpack://./src/sass/layout/navbar/navbar.scss","webpack://./src/sass/layout/navbar/navbar.css","webpack://./src/sass/utilities/_variables.scss"],"names":[],"mappings":"AAGA;EACE,mBAAA;EACA,aAAA;ACFF;;ADIA;EACE,aAAA;ACDF;;;AAGA;EACE,0BAA0B;AAC5B;;AAEA;EDCE,aAAA;ACCF;;AAEA;EACE,aAAa;EDAf,yBAAA;EACE,mBAAA;ECEA,YAAY;EACZ,kBAAkB;ADApB;;ACGA;EACE,aAAa;AACf;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EDAE,gCE1BS;AD4BX;;AAEA;EDAE,qBEpCK;EDsCL,sBAAsB;EACtB,uCAAuC;EDAzC,6BAAA;EACE,6BEzCe;EF0Cf,0CAAA;ACEF;;AAEA;EDAE,qBE3Cc;EF4Cd,gBAAA;EACA,0CAAA;EACA,0BAAA;EACA,iBAAA;EACA,mBAAA;EACA,cAAA;ECEA,UAAU;EACV,kBAAkB;EDApB,mBAAA;EACE,kBEvDK;EFwDL,kBAAA;ACEF;;AAEA;EDAE,0CAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,cAAA;EACA,UAAA;EACA,kBAAA;ECEA,kBAAkB;EDDlB,uBAAA;EACE,sBAAA;ECGF,kBAAkB;EAClB,WAAW;ADDb;ACGA;EDDE,qBAAA;ACGF;;AAEA;EDDE,aAAA;EACA,kCE5Ec;EF6Ed,8BAAA;EACA,qDAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,mBAAA;EACA,UAAA;EACA,kBAAA;ECGA,kBAAkB;EDFlB,uBAAA;EACE,kCAAA;ECIF,kBAAkB;EAClB,WAAW;ADFb;ACIA;EDFE,8BAAA;ACIF;;ADFA;EACE,8BAAA;ECKA,2BAA2B;AAC7B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EDSE,YAAA;ACPF;;AAEA;EDSA,4BAAA;EACE,2BAAA;EACA,oCAAA;ACPF;;AAEA;EDSE,gBAAA;EACA,kBAAA;ECPA,0CAA0C;EAC1C,eAAe;EDSf,gBAAA;EACE,mBAAA;EACA,cAAA;ACPJ;;AAEA;EACE,yBAAyB;EDU3B,4BAAA;EACE,+BAAA;ECRA,YAAY;AACd;;AAEA;EDSE,gCAAA;ACPF;;AAEA;EACE,8BAA8B;EDShC,sBAAA;EACE,uBAAA;EACA,yBAAA;ACPF;;AAEA;EACE,8BAA8B;EDUhC,sBAAA;EACE,uBAAA;EACA,yBAAA;ACRF;;ADWA;EACE,8BAAA;EACA,eAAA;ACRF;;AAEA;EDUA,iBAAA;EACE,sBAAA;ECRA,kBDSE;ACRJ;;AAEA;EACE;IDUE,iBAAA;IACA,kBAAA;ECRF;EDWA;IACE,yBAAA;IACA,YAAA;IACA,aAAA;ECTF;EACA;IACE,WAAW;IDYb,aAAA;IACE,mBAAA;IACA,uBAAA;ICVA,qBAAqB;EDavB;ECXA;IDaE,qBAAA;IACA,uBAAA;ECXF;EACA;IDcE,sBAAA;IACA,oBAAA;ICZA,aAAa;IDcf,mBAAA;IACE,kBAAA;IACA,gBAAA;ICZA,8BAA8B;EDchC;ECZA;IACE,qBAAqB;IDcvB,gBAAA;ECZA;EACA;IDcA,eAAA;ECZA;EACA;IDcA,gBAAA;ECZA;EACA;IDcE,aAAA;ECZF;EACA;IDcE,aAAA;IACA,eAAA;IACA,YAAA;ICZA,kBAAkB;IDcpB,iBAAA;IACE,kBAAA;IACA,kBAAA;IACA,SAAA;ECZF;EACA;IDcA,uBAAA;IACE,wBAAA;ICZA,kCAAkC;IDcpC,8BAAA;ECZA;EACA;IDcE,wBAAA;ECZF;EACA;IDeF,uBAAA;IACE,iBAAA;IACE,2BAAA;ECbF;AACF;AACA;EACE;IDeE,aAAA;IACA,eAAA;IACA,YAAA;ICbA,kBAAkB;IAClB,iBAAiB;IDgBrB,kBAAA;IASE,kBAAA;IACE,oBAAA;ECtBF;AACF;AACA;EACE;IACE,WAAW;IDyBb,mBAAA;IACE,2BAAA;ICvBA,qBAAqB;ID0BvB,aAAA;ECxBA;EACA;ID0BE,qBAAA;ECxBF;EACA;ID0BE,sBAAA;ICxBA,oBAAkB;IAClB,aAAa;ID2BjB,mBAAA;IACE,gBAAA;IACA,8BAAA;EACA;ACzBF;AACA;EACE,eAAe;EACf,YAAY;ED2Bd,kBAAA;EACE,iBAAA;EACA,kBAAA;ACzBF;;AAEA;ED2BA,+BAAA;EACE,iCAAA;EACA,0CAAA;ACzBF;;AAEA;ED2BE,+BAAA;EACA,qDAAA;ECzBA,0CAA0C;EAC1C,8BAA8B;ED2BhC,8CAAA;EACE,YAAA;EACA,WAAA;ACzBF;;AD4BA;EACE,wBAAA;EACA,yBAAA;ACzBF;;AAEA;EACE,6CAA6C;ED2B/C,qDAAA;EACE,eAAA;EACA,2BAAA;ACzBF;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,qBAAqB;AACvB;;AAEA,qCAAqC","sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
